import {combineReducers} from 'redux';

import authReducer from './auth/authReducer.js';
// import itemsReducer from './items/itemsReducer.js';
import filterReducer from './filter/filterReducer.js';
import headerFilter from './headerFilter/filterReducer.js';
import languageReducer from './language/languageReducer.js';

const rootReducer = combineReducers({
  auth: authReducer,
  // items: itemsReducer,
  headerFilter: headerFilter,
  filter: filterReducer,
  language: languageReducer,
});

export default rootReducer;
